<template>
	<div>
		<van-nav-bar title="暗号进群" left-text="返回" left-arrow fixed placeholder @click-left="onClickLeft" v-show="this.$UserAgent.indexOf('Html5Plus')==-1?true:false" />
		<van-form @submit="onSubmit">


			<van-field v-model="invita_content" name="invita_content" label="暗号:" placeholder="如:我要进群" :rules="[{ required: true, message: '请输入暗号' }]"
			 show-word-limit maxlength="6" />
			<div style="margin-left: 0.15rem;">
				<p style="font-size: 10px;font-weight: bold;color: #1989fa;">给{{this.$Setting.web_bot_name}}私聊时发送的暗号</p>
			</div>
			
			<van-field name="autopass_checked" label="自动通过好友">
				<template #input>
					<van-switch v-model="autopass_checked" size="20" />
				</template>
			</van-field>
			
			
			<van-field name="switch_checked" label="是否开启">
				<template #input>
					<van-switch v-model="switch_checked" size="20" />
				</template>
			</van-field>
			
			
			
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">
					提交
				</van-button>
			</div>
		</van-form>
	</div>


</template>

<script>
	import Vue from 'vue';
	import {
		DatetimePicker
	} from 'vant';

	Vue.use(DatetimePicker);
	export default {
		data() {
			return {
				group_id: 0,
				show_time_select: false,
				
				switch_checked: false,
				autopass_checked: false,
				op: 'invita',

				invita_content: ''

			}
		},
		created() {
			var group_id = localStorage.getItem('select_id')
			if (!group_id) {
				this.$router.push('/member-center')
				return;
			}
			this.group_id = group_id

			this.$ApiUtil.GroupCenterSrc.get({
				a: group_id,
				v: this.op
			}).then(res => {
				if (res.status) {
					this.invita_content = res.data.invita_content
					this.switch_checked = res.data.switch_checked
					this.autopass_checked = res.data.autopass_checked
				}
			})
		},
		methods: {
			onClickLeft() {
				this.$router.back()
			},
			onSubmit(values) {
				this.$ApiUtil.GroupCenterSrc.post({
					op: this.op,
					id: this.group_id,
					values: JSON.stringify(values)
				}).then(res => {
					if (!res.status) {
						this.$dialog.alert({
							message: res.message + '\n换一个暗号试试吧'
						})
						return
					}
					this.$toast.success('已保存')
				})
			},
			onChange(e){
				this.show_time_select = false
			},
			onCancel(){
				this.show_time_select = false
			},
			showTimeSelect(){
				this.show_time_select = true
			}
		}
	}
</script>

<style>
</style>
